import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { UIButton } from '../../components/shared/UIButton.styles';

export const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#00C221',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export const ManageCookieActionBt = styled(UIButton)(({ theme }) => ({
  padding: '5px 2px',
  textAlign: 'center',
  alignSelf: 'center',
  minWidth: '180px',
  width: 'auto',
  fontSize: '14px',
  [theme.breakpoints.down('md')]: {
    minWidth: '100%',
  },
}));

export const ManageCookieCategoryHeading = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    rowGap: '8px',
    alignItems: 'flex-start',
  },
}));

export const ManageCookieDescription = styled(Box)(() => ({
  '& p': {
    marginTop: 0,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    fontWeight: 400,
  },
}));
